<template>
  <div>
    <el-select v-if="policy.length > 1"  filterable :value="selected" @input="handleInput" :placeholder="$t('Seçin')" style="width: 100%">
      <el-option v-for="(item, index) in policy" :value="index" 
      :label="(item.policy_number ? item.policy_number  : '') " 
      :key="index"></el-option>
    </el-select>
    <el-input v-else v-model="policyNumber" :disabled="readonly"   @input="handleSingleInput"></el-input>
  </div>
</template>

<script>
export default {
  props: ["policies", "value","policynumber","readonly"],
  
  data() {
    return {
      selected: this.value,
      policy: this.policies,
      policyNumber: this.policynumber,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
      this.$emit("change");
      
      this.$emit('onsearch'); 
    },
    handleSingleInput(e) {
      this.$emit("input", 0);
      this.policyNumber = e;
      this.$emit("change");
      this.$emit('onsearch'); 
    },
    setPolicyNumber() {
      if (this.policy.length === 1) {
        this.policyNumber = this.policy[0].policy_number;
      }
    }
  },
  mounted() {
    this.setPolicyNumber();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    policynumber() {
      this.policyNumber = this.policynumber;
    },
    policies(newPolicies) {
      this.policy = newPolicies;
      this.setPolicyNumber();
    },
  }
};
</script>

<style>
</style>
